import React, { useEffect } from 'react';
import SafeIcon from '../../common/SafeIcon';
import { FiMail, FiZap } from 'react-icons/fi';

const Newsletter = () => {
  useEffect(() => {
    // Create the script element
    const script = document.createElement('script');
    script.src = "https://cdn.sendfox.com/js/embed.js";
    script.setAttribute('data-form', 'm86dv6');
    script.setAttribute('data-api', 'https://sendfox.com');
    script.async = true;

    // Target the specific container for the form
    const container = document.getElementById('sendfox-embed-container');
    if (container) {
      container.appendChild(script);
    }

    // Cleanup on unmount
    return () => {
      if (container && script.parentNode === container) {
        container.removeChild(script);
      }
      // Remove any forms created by the SendFox script
      const injectedForm = document.querySelector('.sendfox-form-container');
      if (injectedForm) injectedForm.remove();
    };
  }, []);

  return (
    <section className="w-full py-24 px-6 bg-[#f4f4f4] border-t-4 border-black">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white border-4 border-black p-8 md:p-16 brutal-shadow text-center relative overflow-hidden">
          {/* Decorative element */}
          <div className="absolute -top-6 -right-6 w-24 h-24 bg-yellow-300 border-4 border-black rotate-12 z-0 hidden md:block"></div>
          
          <div className="relative z-10">
            <div className="inline-flex items-center justify-center p-3 bg-black text-white mb-6">
              <SafeIcon icon={FiMail} className="w-8 h-8" />
            </div>
            
            <h2 className="text-4xl md:text-6xl font-black uppercase tracking-tighter leading-none mb-6">
              STOP RENTING <br />
              <span className="bg-black text-white px-2">YOUR LINKS</span>
            </h2>
            
            <p className="text-xl font-bold text-gray-600 mb-10 max-w-2xl mx-auto uppercase tracking-tight">
              Subscribe to get exclusive lifetime deals, product updates, and tips on optimizing your permanent QR codes.
            </p>

            {/* SendFox Form Container */}
            <div className="max-w-md mx-auto">
              <div 
                id="sendfox-embed-container" 
                className="sendfox-form-wrapper min-h-[100px] flex justify-center"
              >
                {/* SendFox script will inject the form here */}
              </div>
            </div>

            <div className="mt-8 flex items-center justify-center gap-2 text-xs font-black uppercase text-gray-400 tracking-widest">
              <SafeIcon icon={FiZap} className="w-3 h-3" />
              NO SPAM. JUST VALUE. ALWAYS ETERNAL.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;